<template>
	<b-row v-loading="is_loading">
		<b-col cols="12" lg="8">
			<div v-if="!_gHlp.isEmpty(creditReport)">
				<Commitment :credit_report_summary="_gHlp.getValue(creditReport,'credit_report_summary',{})"/>
				<SummaryCcris :summary_ccris="_gHlp.getValue(creditReport,'credit_report_summary.ccris_summary',[])"
					id="card_summary_ccris" />
				<LoanInformation :loan_information="_gHlp.getValue(creditReport,'credit_report_summary.commitments',[])" :is_full="false"
					id="card_loan_information" />
				<MissedPaymentHistory :missed_payment_history="_gHlp.getValue(creditReport,'credit_report_summary.missed_payments',[])"
					id="card_missed_payment_history" />
				<TradeReferences :trade_refferences="_gHlp.getValue(creditReport,'credit_report_summary.trade_references',[])"
					id="card_trade_references" />
				<SpecialAttention :special_attention="_gHlp.getValue(creditReport,'credit_report_summary.special_attensions',[])"
					id="card_special_attention" />
				<LegalSts :legal_sts="_gHlp.getValue(creditReport,'credit_report_summary.legal_sts',[])"
					id="card_legal_sts"/>
				<LegalCases :legal_cases="_gHlp.getValue(creditReport,'credit_report_summary.legal_cases',[])"
					id="card_legal_cases" />
				<Bankruptcy :bankruptcy="_gHlp.getValue(creditReport,'credit_report_summary.bankruptcies',[])"
					id="card_bankruptcy" />
				<AkpkCard :akpk_card="_gHlp.getValue(creditReport,'credit_report_summary.akpk',[])"
					id="card_akpk_" />
				<AngkasaReport 
					:angkasa_report="_gHlp.getValue(creditReport,'credit_report_summary.angkasa_reports.0.aks_rep_items',[])" 
					:angkasa_total="_gHlp.getValue(creditReport,'credit_report_summary.angkasa_reports.0.aks_rep_total_deduction',0)"
					id="card_angkasa_report" />
			</div>
			<div v-else class="bg-light p-3 text-center rounded-bottom">
				<p class="text-xs">No Credit Report Purchased</p>
			</div>
		</b-col>
		<b-col cols="12" lg="4">
			<FintscoreReport />
			<CcrisDerivatives :ccris-derivatives="_gHlp.getValue(creditReport,'credit_report_summary.ccris_derivatives',{})"/>
			<CreditInfo :credit-info="_gHlp.getValue(creditReport,'credit_report_summary.credit_info_of_glance',{})"/>
		</b-col>
	</b-row>
</template>

<script>
import Commitment from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/Commitment'
import SummaryCcris from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/SummaryCCRIS'
import MissedPaymentHistory from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/MissedPayment'
import TradeReferences from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/TradeReferences'
import SpecialAttention from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/SpecialAttention'
import LegalSts from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/LegalSts'
import LegalCases from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/LegalCases'
import Bankruptcy from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/Bankruptcy'
import AkpkCard from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/AkpkCard'
import AngkasaReport from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/AngkasaReport'
import LoanInformation from '@/views/CustomerProfile/CenterComponents/Commitments/Cards/LoanInformation'
import FintscoreReport from '@/views/CustomerProfile/CenterComponents/Commitments/FintscoreReport'
import CcrisDerivatives from '@/views/CustomerProfile/CenterComponents/Commitments/CcrisDerivatives'
import CreditInfo from '@/views/CustomerProfile/CenterComponents/Commitments/CreditInfo'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useCreditReportStore } from '@/stores/creditReportStore';

export default {
	components: {
		Commitment,
		SummaryCcris,
		MissedPaymentHistory,
		TradeReferences,
		SpecialAttention,
		LegalSts,
		LegalCases,
		Bankruptcy,
		AkpkCard,
		AngkasaReport,
		LoanInformation,
		FintscoreReport,
		CcrisDerivatives,
		CreditInfo,
	},
	data(){
		return {
			creditReport:{}
		}
	},
	computed: {
		...mapState(useCreditReportStore, ['activeCreditReport']),
		is_loading(){
			return _gHlp.isLoading('fetch_credit_report') || _gHlp.isLoading('fetch_loan_ec') || _gHlp.isLoading('fetch_customer')
		}
	},
	watch: {
		activeCreditReport: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.creditReport = newVal
				}
			}
		},
	},
	methods:{
		goSection(card) {
			const cardElement = document.getElementById(card);

			if (cardElement) {
				// Using standard JavaScript to scroll smoothly
				window.scrollTo({
					top: cardElement.offsetTop,
					behavior: 'smooth',
				});
			}
		}
	}
}
</script>